import { render, staticRenderFns } from "./simOpenLex.vue?vue&type=template&id=5504fb87&scoped=true&"
import script from "./simOpenLex.vue?vue&type=script&lang=js&"
export * from "./simOpenLex.vue?vue&type=script&lang=js&"
import style0 from "./simOpenLex.vue?vue&type=style&index=0&id=5504fb87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5504fb87",
  null
  
)

export default component.exports